export const NoTerminals = ({ className }: { className?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M32.1663 53.282H37.4997V18.6153L56.1663 28.3737V53.282H61.4997V58.6154H2.83301V53.282H8.16634V17.6817L32.1663 5.50098V53.282Z"
      fill="#B2ABAB"
    />
  </svg>
);
